import { render, staticRenderFns } from "./veStuCheckItemStu.vue?vue&type=template&id=85875fac&scoped=true"
import script from "./veStuCheckItemStu.vue?vue&type=script&lang=js"
export * from "./veStuCheckItemStu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85875fac",
  null
  
)

export default component.exports